var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFieldlarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 217,
    viewBox: "0 0 217 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 216,
    height: 46,
    rx: 8.5,
    fill: "#313344",
    stroke: "url(#paint0_linear_626_3528)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.27668 10.1475C7.69132 7.43748 10.5477 5.92748 15.9535 5.42748C25.8585 4.57528 35.9242 5.00001 45.5774 6.67748C53.3713 8.04482 61.5625 8.14098 69.427 6.95748C81.7128 5.10748 94.2749 5.28748 106.837 5.88748C124.898 6.68233 143.014 6.79251 161.094 6.21749C164.165 6.27749 164.856 7.34749 165.01 7.75749L165.701 15.4375L173.134 7.12749C173.528 6.75746 174.036 6.44467 174.626 6.20888C175.215 5.97308 175.873 5.81939 176.558 5.75749L176.988 5.75749C178.398 5.79153 179.745 6.14525 180.797 6.75749L185.174 9.86749L191.977 6.34749C193.479 5.7914 195.165 5.47925 196.891 5.43749L198.519 5.43749C199.935 5.42899 201.35 5.50936 202.742 5.67749C208.64 6.30749 211.342 7.67749 210.59 10.6775C209.054 16.5975 207.104 22.4975 205 28.3775C204.094 30.8975 200.562 32.6775 195.786 33.4475C190.011 34.3875 186.756 36.1975 185.036 39.0175C184.683 39.431 184.201 39.7921 183.622 40.0779C183.043 40.3636 182.379 40.5678 181.672 40.6775C175.53 41.4775 169.279 42.0675 163.689 42.6775C151.987 41.8075 141.13 41.1375 130.38 40.1675C113.118 38.5975 95.7953 39.3875 78.4724 39.5175C68.1063 39.5875 57.7403 39.6775 47.3742 39.7375C47.0061 39.756 46.6365 39.756 46.2685 39.7375C44.7327 39.6775 42.4138 39.3375 42.337 37.7375L43.0281 28.5675L34.1056 37.2675C34.1056 37.2675 31.587 39.6975 27.5174 39.0575L27.0413 38.9775C21.8506 37.9775 19.1631 35.9275 18.9174 32.8675C18.8253 31.7675 18.9174 30.6675 18.9174 29.5575C18.87 28.3529 18.4545 27.1665 17.6951 26.0676C16.9357 24.9688 15.8477 23.9795 14.4945 23.1575C11.8596 21.4852 9.84113 19.4457 8.59096 17.1923C7.34079 14.9389 6.89144 12.5302 7.27668 10.1475Z",
    fill: "#3D4055"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_626_3528",
    x1: 108.5,
    y1: 1,
    x2: 108.5,
    y2: 46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C5067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C5067",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFieldlarge);
export default __webpack_public_path__ + "static/media/fieldlarge.01190f92422248f9ee7f9f7df8f0ca5b.svg";
export { ForwardRef as ReactComponent };